import * as benchlingUtil from 'BenchlingUtil';

import UserConstants from '../constants/UserConstants';
import preferences from '../Preferences';
import {BenchlingLocale} from './AllLanguageTags';
import {DEFAULT_LANGUAGE_TAG} from './LanguageTagConstants';

const {LANGUAGE_PREFERENCE_KEY} = UserConstants;

// Attempts to get the current user's general language preference key before defaulting to
//  the default language tag.
export const safelyGetUserLocale = (): string =>
  preferences.get(LANGUAGE_PREFERENCE_KEY) ?? DEFAULT_LANGUAGE_TAG.code;

export function isLocaleSupported(locale: string): boolean {
  return Object.values(BenchlingLocale).includes(locale as BenchlingLocale);
}

export function getNavigatorLocaleIfSupported(): string | null {
  const navigatorLanguage = benchlingUtil.navigatorLanguage;
  if (navigatorLanguage != null && isLocaleSupported(navigatorLanguage)) {
    return navigatorLanguage;
  }
  return null;
}
